/*
ROUTES

You can add the following line to any entry to restrict it by login: meta: { requiresAuth: true }
For example:
{
  path: "charts",
  name: "Charts",
  components: { default: Charts },
  meta: { requiresAuth: true }
},
 */

import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Layout/AuthLayout.vue";

import ReleaseNotes from "@/pages/ReleaseNotes.vue";
// Dashboard pages
import Dashboard from "@/pages/Dashboard.vue";

import Companies from "@/pages/Companies/Companies.vue";
import Company from "@/pages/Companies/Company.vue";

import Accounts from "@/pages/Accounts/Accounts.vue";
import Account from "@/pages/Accounts/Account.vue";

import Services from "@/pages/Services/Services.vue";
import Service from "@/pages/Services/Service.vue";

import Products from "@/pages/Products/Products.vue";
import Product from "@/pages/Products/Product.vue";

import Portfolios from "@/pages/Portfolios/Portfolios.vue";
import Portfolio from "@/pages/Portfolios/Portfolio.vue";

import Teams from "@/pages/Teams/Teams.vue";
import Team from "@/pages/Teams/Team.vue";

import People from "@/pages/People/People.vue";
import Person from "@/pages/People/Person.vue";

import Salesreps from "@/pages/Salesreps/Salesreps.vue";
import Salesrep from "@/pages/Salesreps/Salesrep.vue";

import Tasks from "@/pages/Tasks/Tasks.vue";
import Task from "@/pages/Tasks/Task.vue";

import TaskTemplates from "@/pages/TaskTemplates/TaskTemplates.vue";
import TaskTemplate from "@/pages/TaskTemplates/TaskTemplate.vue";

import Users from "@/pages/Users/Users.vue";
import User from "@/pages/Users/User.vue";

import Cases from "@/pages/Cases/Cases.vue";
import Case from "@/pages/Cases/Case.vue";

import CaseTemplates from "@/pages/CaseTemplates/CaseTemplates.vue";
import CaseTemplate from "@/pages/CaseTemplates/CaseTemplate.vue";

import ProductOptions from "@/pages/ProductOptions/ProductOptions.vue";
import ProductOption from "@/pages/ProductOptions/ProductOption.vue";

import Messages from "@/pages/Messages/Messages.vue";

import Notes from "@/pages/Notes/Notes.vue";

import Comments from "@/pages/Comments/Comments.vue";

import HQs from "@/pages/HQ/HQs.vue";
import HQ from "@/pages/HQ/HQ.vue";

import SalesOffices from "@/pages/SalesOffices/SalesOffices.vue";
import SalesOffice from "@/pages/SalesOffices/SalesOffice.vue";

// Pages
import UserProfile from "@/pages/UserProfile/UserProfile.vue";
import Pricing from "@/pages/Pricing.vue";
import TimeLine from "@/pages/TimeLinePage.vue";
//import RtlSupport from "@/pages/RtlSupport.vue";
import Login from "@/pages/Login.vue";
// import Register from "@/pages/Register.vue";
import Lock from "@/pages/Lock.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";

// Components pages
import Buttons from "@/pages/Examples/Components/Buttons.vue";
import GridSystem from "@/pages/Examples/Components/GridSystem.vue";
import Panels from "@/pages/Examples/Components/Panels.vue";
import SweetAlert from "@/pages/Examples/Components/SweetAlert.vue";
import Notifications from "@/pages/Examples/Components/Notifications.vue";
import Icons from "@/pages/Examples/Components/Icons.vue";
import Typography from "@/pages/Examples/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Examples/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Examples/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Examples/Forms/ValidationForms.vue";
import Wizard from "@/pages/Examples/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Examples/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Examples/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Examples/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Examples/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Examples/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Examples/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Examples/Calendar.vue";
// Charts
import Charts from "@/pages/Examples/Charts.vue";
import Widgets from "@/pages/Examples/Widgets.vue";

//Reports
import Bonuses from "@/pages/Reports/Bonus.vue";
import ConversionBonuses from "@/pages/Reports/ConversionBonus.vue";
import ClawbackClosedNeverLiveVsApprovalDate from "@/pages/Reports/ClawbackClosedNeverLiveVsApprovalDate.vue";
import ClawbackRatesLowered from "@/pages/Reports/ClawbackRatesLowered.vue";
import BetaServices from "@/pages/Reports/BetaServices.vue";

import ReportFilter from "@/pages/Reports/include/ReportFilter.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let reportsMenu = {
  path: "/reports",
  component: DashboardLayout,
  redirect: "/reports/bonus",
  name: "Reports",
  children: [
    {
      path: "bonus",
      name: "Bonuses",
      components: { default: Bonuses }
    },
    {
      path: "conversion-bonus",
      name: "Conversion Bonuses",
      components: { default: ConversionBonuses }
    },
    {
      path: "clawback-closed-never-live-vs-approval-date",
      name: "Clawback: Closed/Never Live vs Approval Date",
      components: { default: ClawbackClosedNeverLiveVsApprovalDate }
    },
    {
      path: "clawback-rates-lowered",
      name: "Clawback: Rates Lowered",
      components: { default: ClawbackRatesLowered }
    },
    {
      path: "beta-services",
      name: "BETA Services",
      components: { default: BetaServices }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: UserProfile },
      meta: { requiresAuth: true }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    // {
    //   path: "rtl",
    //   name: "وحة القيادة",
    //   meta: {
    //     rtlActive: true
    //   },
    //   components: { default: RtlSupport }
    // }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    // {
    //   path: "/register",
    //   name: "Register",
    //   component: Register
    // },
    // {
    //   path: "/pricing",
    //   name: "Pricing",
    //   component: Pricing
    // },
    // {
    //   path: "/lock",
    //   name: "Lock",
    //   component: Lock
    // },
    {
      path: "/forgotPassword",
      name: "Forgot Password",
      component: ForgotPassword
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
    meta: { requiresAuth: true, breadcrumb: [ { name: 'Home', path: "/" } ] }
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  reportsMenu,
  pagesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    meta: { requiresAuth: true, breadcrumb: [{ name: "Home", path: "/" }] },
    children: [
      {
        path: "releasenotes",
        name: "Release Notes",
        components: { default: ReleaseNotes },
        meta: { breadcrumb: [{ name: "ReleaseNote" }] }
      },

      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: { breadcrumb: [{ name: "Dashboard" }] }
      },


      {
        path: "companies",
        name: "Companies",
        components: { default: Companies },
        meta: { breadcrumb: [{ name: "Companies" }]},
      },
      {
        path: "companies/new",
        name: "New Company",
        exact: true,
        component: Company,
        meta: { breadcrumb: [{ name: "Company" }]}
      },
      {
        path: "companies/:id",
        name: "View Company",
        component: Company,
        meta: { breadcrumb: [
                  { name: "Companies", path: "/companies" },
                  { name: "Company" }
        ] },
        children: [
          {
            path: "accounts",
            name: "Company Accounts",
            meta: {tab: 'accounts', breadcrumb: [{ name: "Accounts" }]},
            component: Company,
          },
          {
            path: "services",
            name: "Company Services",
            meta: {tab: 'services', breadcrumb: [{ name: "Services" }]},
            component: Company,
          },
          {
            path: "people",
            name: "Company People",
            meta: {tab: 'people', breadcrumb: [{ name: "People" }]},
            component: Company,
          },
          {
            path: "cases",
            name: "Company Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "Company Tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Task,
          }
        ]
      },


      {
        path: "accounts",
        name: "Accounts",
        components: { default: Accounts },
        meta: { breadcrumb: [{ name: "Accounts" }]},
      },
      {
        path: "accounts/new",
        name: "New Account",
        exact: true,
        component: Account,
        meta: { breadcrumb: [{ name: "Account" }]},
      },
      {
        path: "accounts/:id",
        name: "View Account",
        component: Account,
        meta: { breadcrumb: [
                  { name: "Accounts", path: "/accounts" },
                  { name: "Account" }
        ], 
        quickLinks: {
          showQuickLinks: true,
          links: [
            {id: "AccountInformation", label: "Account Information"},
            {id: "BankAccount", label: "Bank Account"},
            {id: "Address", label: "Address"},
          ]
        } },
        children: [
          {
            path: "services",
            name: "Account Services",
            meta: {tab: 'services', breadcrumb: [{ name: "Services" }]},
            component: Account,
          },
          {
            path: "products",
            name: "Account Products",
            meta: {tab: 'products', breadcrumb: [{ name: "Products" }]},
            component: Account,
          },
          {
            path: "people",
            name: "Account People",
            meta: {tab: 'people', breadcrumb: [{ name: "People" }]},
            component: Account,
          },
          {
            path: "cases",
            name: "Account Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "Account Tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Task,
          }
        ]
      },


      {
        path: "services",
        name: "Services",
        components: { default: Services },
        meta: { breadcrumb: [{ name: "Services" }]},
      },
      {
        path: "services/new",
        name: "New Service",
        exact: true,
        component: Service,
        meta: { breadcrumb: [{ name: "Service" }]},
      },
      {
        path: "services/:id",
        name: "View Service",
        component: Service,
        meta: { 
          sidebar: {
            isEnabled: true,
            isOpen: true,
            activeTabId: 'service-feed',
            tabs: [
              { id: 'service-feed', icon: 'history', label: 'Feed' },
              { id: 'service-account', icon: 'work', label: 'Accounts', isDisabled: true },
              { id: 'service-attachments', icon: 'attach_file', label: 'Files', isDisabled: false, badge: 0 },
            ],
            quickInfoItems: [],
          },
          breadcrumb: [
	          { name: "Services", path: "/services" },
	          { name: "Service" }
          ],
          quickLinks: {
            showQuickLinks: true,
            links: [
              {id: "ServiceInformation", label: "Service Information"},
              {id: "Address", label: "Address"},
              {id: "Status", label: "Status"},
              {id: "BankingInformation", label: "Banking Information"},
              {id: "CardTypes", label: "Card Types"},
              {id: "BusinessInformation", label: "Business Information"},
              {id: "AccountClosure", label: "Account Closure"}
            ]
          }
        },
        children: [
          {
            path: "products",
            name: "Service Products",
            meta: {tab: 'products', breadcrumb: [{ name: "Products" }]},
            component: Service
          },
          {
            path: "portfolios",
            name: "Service Portfolios",
            meta: {tab: 'portfolios', breadcrumb: [{ name: "Portfolios" }]},
            component: Service,
          },
          {
            path: "cases",
            name: "Service Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "Services Tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Task,
          }
        ]
      },


      {
        path: "products",
        name: "Products",
        components: { default: Products },
        meta: { breadcrumb: [{ name: "Products" }]},
      },
      {
        path: "products/new",
        name: "New Product",
        exact: true,
        components: { default: Product },
        meta: { breadcrumb: [{ name: "Product" }]},
      },
      {
        path: "products/:id",
        name: "View Product",
        component: Product,
        meta: {
          sidebar: {
            isEnabled: true,
            isOpen: true,
            activeTabId: 'dependents',
            tabs: [
              { id: 'dependents', icon: 'device_hub', label: 'Dependencies', badge: 0 }
            ]
          },
          breadcrumb: [
                  { name: "Products", path: "/products" },
                  { name: "Product" }
          ], 
          quickLinks: {
            showQuickLinks: true,
            links: [
              {id: "BasicInformation", label: "Basic Information"},
              {id: "Features", label: "Features"},
              {id: "Equipment", label: "Equipment"},
              {id: "FileBuildInfo", label: "File Build Info"},
              {id: "StaticInformation", label: "Static Information"},
              {id: "DownloadInformation", label: "Download Information"}
            ]
          } 
        },
        children: [
          {
            path: "extra",
            name: "Product Extra",
            meta: {tab: 'extra', breadcrumb: [{ name: "Extra" }]},
            component: Product,
          },
          {
            path: "other",
            name: "Product Other",
            meta: {tab: 'other', breadcrumb: [{ name: "Other" }]},
            component: Product,
          },
          {
            path: "cases",
            name: "Product Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "Product Tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Task,
          }
        ]
      },
      {
        path: "portfolios",
        name: "Portfolios",
        components: { default: Portfolios },
        meta: { breadcrumb: [{ name: "Portfolios" }]},
      },
      {
        path: "portfolios/new",
        name: "New Portfolio",
        exact: true,
        components: { default: Portfolio },
        meta: { breadcrumb: [{ name: "Portfolio" }]},
      },
      {
        path: "portfolios/:id",
        name: "View Portfolio",
        component: Portfolio,
        meta: { breadcrumb: [
                  { name: "Portfolios", path: "/portfolios" },
                  { name: "Portfolio" }
        ] },
        children: [
          {
            path: "services",
            name: "Portfolio Services",
            meta: {tab: 'services', breadcrumb: [{ name: "Services" }] },
            component: Portfolio,
          }
        ]
      },
      {
        path: "teams",
        name: "Teams",
        components: { default: Teams },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Teams" }] },
      },
      {
        path: "teams/new",
        name: "New Team",
        exact: true,
        components: { default: Team },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Team" }] },
      },
      {
        path: "teams/:id",
        name: "View Team",
        component: Team,
        meta: { isAdminOnly: true, 
                breadcrumb: [
                      { name: "Teams", path: "/teams" },
                      { name: "Team" }
        ] },
        children: [
          {
            path: "users",
            name: "Team Users",
            meta: {tab: 'users', isAdminOnly: true, breadcrumb: [{ name: "Users" }]},
            component: Team,
          }
        ]
      },
      {
        path: "people",
        name: "People",
        components: { default: People },
        meta: { breadcrumb: [{ name: "People" }]},
      },
      {
        path: "people/new",
        name: "New Person",
        exact: true,
        components: { default: Person },
        meta: { breadcrumb: [{ name: "Person" }]},
      },
      {
        path: "people/:id",
        name: "View Person",
        component: Person,
        meta: { breadcrumb: [
                  { name: "People", path: "/people" },
                  { name: "Person" }
        ] },
        children: [
          {
            path: "companies",
            name: "Person Companies",
            meta: {tab: 'companies', breadcrumb: [{ name: "Companies" }] },
            component: Person,
          },
          {
            path: "accounts",
            name: "Person Accounts",
            meta: {tab: 'accounts', breadcrumb: [{ name: "Accounts" }]},
            component: Person,
          },
          {
            path: "cases",
            name: "Person Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Person,
          }
        ]
      },

      {
        path: "salesreps",
        name: "Salesreps",
        components: { default: Salesreps },
        meta: { breadcrumb: [{ name: "Salesreps" }]},
      },
      {
        path: "salesreps/new",
        name: "New Salesrep",
        exact: true,
        components: { default: Salesrep },
        meta: { breadcrumb: [{ name: "Salesrep" }]},
      },
      {
        path: "salesreps/:id",
        name: "View Salesrep",
        component: Salesrep,
        meta: { breadcrumb: [
                  { name: "Salesresps", path: "/salesreps" },
                  { name: "Salesresp" }
        ] },
        children: [
          {
            path: "cases",
            name: "SalesReps Cases",
            meta: {tab: 'cases', breadcrumb: [{ name: "Cases" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "SalesReps Tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Task,
          }
        ]
      },

      {
        path: "tasks",
        name: "Tasks",
        components: { default: Tasks },
        meta: { breadcrumb: [{ name: "Tasks" }]},
      },
      {
        path: "tasks/new",
        name: "New Task",
        exact: true,
        components: { default: Task },
        meta: { breadcrumb: [{ name: "Task" }]},
      },
      {
        path: "tasks/:id",
        name: "View Task",
        component: Task,
        meta: {
          sidebar: {
            isEnabled: true,
            isOpen: true,
            activeTabId: 'feed',
            tabs: [
              { id: 'feed', icon: 'history', label: 'Feed' },
              { id: 'details', icon: 'assignment', label: 'Details', isDisabled: true },
              { id: 'targets', icon: 'gps_fixed', label: 'Targets', isDisabled: true },
              { id: 'links', icon: 'insert_link', label: 'Cases', isDisabled: true },
              { id: 'attachments', icon: 'attach_file', label: 'Files', isDisabled: true },
            ],
            quickInfoItems: [],
          },
          breadcrumb: [
            { name: "Tasks", path: "/tasks" },
            { name: "Task" }
          ] 
        },
        children: [
          {
            path: "comments",
            name: "Task comments",
            meta: {tab: 'comments', breadcrumb: [{ name: "Comments" }]},
            component: Task,
          }
        ]        
      },
      
      {
        path: "tasktemplates",
        name: "TaskTemplates",
        components: { default: TaskTemplates },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "TaskTemplates" }] },
      },
      {
        path: "tasktemplates/new",
        name: "New TaskTemplate",
        exact: true,
        components: { default: TaskTemplate },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "TaskTemplate" }] },
      },
      {
        path: "tasktemplates/:id",
        name: "View TaskTemplate",
        component: TaskTemplate,
        meta: { isAdminOnly: true, breadcrumb: [
                  { name: "TaskTemplates", path: "/tasktemplates" },
                  { name: "TaskTemplate" }
        ]},
      },

      {
        path: "users",
        name: "Users",
        components: { default: Users },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Users" }] },
      },
      {
        path: "users/new",
        name: "New User",
        exact: true,
        components: { default: User },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "User" }] },
      },
      {
        path: "users/:id",
        name: "View User",
        component: User,
        meta: { isAdminOnly: true, breadcrumb: [
                  { name: "Users", path: "/users" },
                  { name: "User" }
        ] },
        children: [
          {
            path: "groups",
            name: "User Groups",
            component: User,
            meta: {tab: 'groups', isAdminOnly: true, breadcrumb: [{ name: "Groups" }]},
          },
          {
            path: "teams",
            name: "User Teams",
            component: Team,
            meta: {tab: 'teams', isAdminOnly: true, breadcrumb: [{ name: "Teams" }]},
          },
          {
            path: "companies",
            name: "User Companies",
            component: User,
            meta: {tab: 'companies', isAdminOnly: true, breadcrumb: [{ name: "Companies" }]},
          },
          {
            path: "accounts",
            name: "User Accounts",
            component: User,
            meta: {tab: 'accounts', isAdminOnly: true, breadcrumb: [{ name: "Accounts" }]},
          }
        ]
      },

      {
        path: "casetemplates",
        name: "Case Templates",
        components: { default: CaseTemplates },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Case Templates" }] },
      },
      {
        path: "casetemplates/new",
        name: "New CaseTemplate",
        exact: true,
        components: { default: CaseTemplate },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Case Template" }] },
      },
      {
        path: "casetemplates/:id",
        name: "View CaseTemplate",
        component: CaseTemplate,
        meta: { isAdminOnly: true, breadcrumb: [
                  { name: "Case Templates", path: "/casetemplates" },
                  { name: "Case Template" }
        ] },
      },

      {
        path: "productoptions",
        name: "Product Options",
        components: { default: ProductOptions },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Product Options" }] },
      },
      {
        path: "productoptions/new",
        name: "New Product Option",
        exact: true,
        components: { default: ProductOption },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Product Options" }] },
      },
      {
        path: "productoptions/:id",
        name: "View Product Option",
        component: ProductOption,
        meta: {
          isAdminOnly: true,
          sidebar: {
            isEnabled: true,
            isOpen: true,
            activeTabId: 'dependents',
            tabs: [
              { id: 'dependents', icon: 'device_hub', label: 'Dependencies', badge: 0 }
            ]
          },
          breadcrumb: [
                  { name: "Product Options", path: "/productoptions" },
                  { name: "Product Option" }
          ]
        },
      },

      {
        path: "cases",
        name: "Cases",
        components: { default: Cases },
        meta: { breadcrumb: [{ name: "Cases" }]},
      },
      {
        path: "cases/new",
        name: "New Case",
        exact: true,
        components: { default: Case },
        meta: { breadcrumb: [{ name: "Case" }]},
      },
      {
        path: "cases/:id",
        name: "View Case",
        component: Case,
        meta: { 
          requiresAuth: true,
          sidebar: {
            isEnabled: true,
            isOpen: true,
            activeTabId: 'feed',
            tabs: [
              { id: 'feed', icon: 'history', label: 'Feed', isDisabled: false },
              {
                id: 'details',
                icon: 'assignment',
                label: 'Task Details',
                isDisabled: true,
                title: 'Task needs to be selected before you can review the details on the tab',
              },
              { id: 'targets', icon: 'gps_fixed', label: 'Targets', isDisabled: false, badge: 0 },
              { id: 'links', icon: 'insert_link', label: 'Linked Cases', isDisabled: false, badge: 0 },
              { id: 'attachments', icon: 'attach_file', label: 'Files', isDisabled: false, badge: 0 },
            ],
            quickInfoItems: [],
          },
          breadcrumb: [
                  { name: "Cases", path: "/cases" },
                  { name: "Case" }
          ], 
          quickLinks: {
            showQuickLinks: true,
            links: [
              {id: "CaseDetails", label: "Case Details"},
              {id: "CaseTargets", label: "Case Targets"},
              {id: "Tasks", label: "Tasks"},
            ]
          }
       },
        children: [
          {
            path: "messages",
            name: "Case Messages",
            meta: {tab: 'messages', breadcrumb: [{ name: "Messages" }]},
            component: Case,
          },
          {
            path: "tasks",
            name: "Case tasks",
            meta: {tab: 'tasks', breadcrumb: [{ name: "Tasks" }]},
            component: Case,
          },
          {
            path: "notes",
            name: "Case Notes",
            meta: {tab: 'notes', breadcrumb: [{ name: "Notes" }]},
            component: Case,
          },
          {
            path: "comments",
            name: "Case Comments",
            meta: {tab: 'comments', breadcrumb: [{ name: "Comments" }]},
            component: Case,
          },
        ]
      },

      {
        path: "messages",
        name: "Messages",
        components: { default: Messages },
        meta: { breadcrumb: [{ name: "Messages" }] },
      },

      {
        path: "notes",
        name: "Notes",
        components: { default: Notes },
        meta: { breadcrumb: [{ name: "Notes" }] },
      },

      {
        path: "comments",
        name: "Comments",
        components: { default: Comments },
        meta: { breadcrumb: [{ name: "Comments" }]},
      },

      {
        path: "hq",
        name: "HQs",
        components: { default: HQs },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "HQs" }] },
      },
      {
        path: "hq/new",
        name: "New HQ",
        exact: true,
        components: { default: HQ },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "HQ" }] },
      },
      {
        path: "hq/:id",
        name: "View HQ",
        component: HQ,
        meta: { isAdminOnly: true, breadcrumb: [
                  { name: "HQs", path: "/hq" },
                  { name: "HQ" }
        ] },
        children: [
          {
            path: "companies",
            name: "HQ Companies",
            meta: { tab: 'companies', isAdminOnly: true, breadcrumb: [{ name: "Companies" }] },
            component: HQ
          }
        ]
      },

      {
        path: "salesoffice",
        name: "Sales Offices",
        components: { default: SalesOffices },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Sales Offices" }] },
      },
      {
        path: "salesoffice/new",
        name: "New Sales Office",
        exact: true,
        components: { default: SalesOffice },
        meta: { isAdminOnly: true, breadcrumb: [{ name: "Sales Office" }] },
      },
      {
        path: "salesoffice/:id",
        name: "View Sales Office",
        component: SalesOffice,
        meta: { isAdminOnly: true, breadcrumb: [
                  { name: "Sales Offices", path: "/salesoffice" },
                  { name: "Sales Office" }
        ] },
      },

      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar },
        meta: { breadcrumb: [{ name: "Calendar" }]}
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts },
        meta: { breadcrumb: [{ name: "Charts" }]}
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets },
        meta: { breadcrumb: [{ name: "Widgets" }]}
      }
    ]
  }
];

export default routes;
